// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { LangLink as Link } from "@/components/LangLink";
import { PageShell, PageHero } from "@/components/PageShell";
import { CategoryProductGrid } from "@/components/CategoryProductGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/hero-chemicals.png";
import htpImage from "@/assets/htp.png";
import catalystImage from "@/assets/catalyst.png";

export const Route = createFileRoute("/$lang/category/chemicals")({
  head: () => ({
    meta: [
      { title: i18n.t("category/chemicals:metaTitle", "Chemicals & HTP — BIZU Space") },
      {
        name: "description",
        content: i18n.t("category/chemicals:metaDesc",
          "High-performance aerospace chemicals and hydrogen peroxide catalysts produced with strict quality and safety standards by BIZU Space.",
        ),
      },
      { property: "og:title", content: i18n.t("category/chemicals:metaTitle", "Chemicals & HTP — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("category/chemicals:metaOgDesc",
          "Developing High-Test Peroxide (HTP) and decomposition catalysts for green aerospace propulsion units.",
        ),
      },
      { property: "og:url", content: "/category/chemicals" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/category/chemicals" }],
  }),
  component: Chemicals,
});

function Chemicals() {
  const { t } = useTranslation("category/chemicals");

  const products = [
    {
      name: t("htpName", "High-Test Peroxide (HTP)"),
      link: "/products/htp",
      image: htpImage,
      buttonText: t("htpBtn", "Check it out"),
    },
    {
      name: t("catalystName", "Hydrogen Peroxide Catalysts"),
      link: "/products/catalyst",
      image: catalystImage,
      buttonText: t("catalystBtn", "Check it out"),
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "Chemicals")}
        description={t("heroDesc",
          "Development and supply of high-performance propellants and catalysts, focusing on HTP and safe, efficient chemical solutions for space applications.",
        )}
        image={heroImage}
      />
            {/* TITLE SECTION */}
      <section className="pt-20">
        <div className="container-bizu">
          <h2 className="display text-4xl md:text-5xl text-center">
            {t("sectionTitle", "Technological capability in hydrogen peroxide propulsion")}
          </h2>
        </div>
      </section>
            {/* PRODUCTS SECTION */}
      <CategoryProductGrid products={products} />
    </PageShell>
  );
}
